import React from 'react'
import styled from 'styled-components'

const IconWrapper = styled.div`
  position: absolute;
  top: -70px;
  left: 150px;
  z-index: -1;
  height: 472px;
  width: 758px;

  @media (max-width: 959px) {
    top: -70px;
    left: -250px;
    svg {
      height: 470px;
    }
  }
`

const Icon = () => (
  <IconWrapper>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 1011.237 630.935"
    >
      <defs>
        <clipPath id="clip-path-2">
          <rect
            id="Rectangle_414"
            data-name="Rectangle 414"
            width="1011.237"
            height="630.935"
            fill="#dfe4eb"
          />
        </clipPath>
      </defs>
      <g id="Group_406" data-name="Group 406" opacity="0.3">
        <g id="Group_405" data-name="Group 405" clipPath="url(#clip-path-2)">
          <path
            id="Path_220"
            data-name="Path 220"
            d="M930.394,426.233a4.679,4.679,0,0,0,0-6.61L626.915,116.076C589.292,78.5,537.337,60.492,483.361,67.248c-39.568,4.951-75.62,25.431-103.82,53.631L80.856,419.553a4.679,4.679,0,0,0,0,6.61L163.2,508.5a4.649,4.649,0,0,0,6.6,0L466.982,211.313a54.629,54.629,0,0,1,77.287,0L841.486,508.531a4.649,4.649,0,0,0,6.6,0ZM0,422.854A37.472,37.472,0,0,1,10.994,396.3L337.776,69.514c92.7-92.685,243-92.685,335.691,0L1000.256,396.3a37.65,37.65,0,0,1,0,53.152L871.378,578.35a37.6,37.6,0,0,1-53.177.017L508.929,269.1a4.649,4.649,0,0,0-6.6,0L193.049,578.35a37.574,37.574,0,0,1-53.142,0L10.994,449.448A37.5,37.5,0,0,1,0,422.854"
            transform="translate(0 0)"
            fill="#dfe4eb"
          />
          <path
            id="Path_221"
            data-name="Path 221"
            d="M301.687,153.733,324.8,224.866a15.255,15.255,0,0,0,14.506,10.541h74.8c14.777,0,20.921,18.908,8.967,27.594l-60.509,43.963a15.25,15.25,0,0,0-5.542,17.053l23.112,71.133c4.567,14.053-11.518,25.739-23.473,17.053l-60.509-43.963a15.257,15.257,0,0,0-17.931,0L217.705,412.2c-11.955,8.686-28.037-3-23.473-17.053l23.112-71.133a15.249,15.249,0,0,0-5.54-17.053L151.295,263c-11.954-8.686-5.811-27.594,8.966-27.594h74.793a15.253,15.253,0,0,0,14.506-10.541l23.114-71.133c4.565-14.053,24.445-14.053,29.013,0"
            transform="translate(218.439 215.75)"
            fill="#dfe4eb"
          />
        </g>
      </g>
    </svg>
  </IconWrapper>
)

export default Icon
